import { createLazyComponent, LazyModule } from 'owa-bundling';
var lazyModule = new LazyModule(function () {
    return System.import(/* webpackChunkName: "FavoriteContextMenu" */ './lazyIndex');
});
// Delay loaded components
export var FavoriteNodeContextMenu = createLazyComponent(lazyModule, function (m) { return m.FavoriteNodeContextMenu; });
export { default as Favorites } from './components/Favorites';
export { default as FavoritePersonaNode } from './components/FavoritePersonaNode';
//# sourceMappingURL=index.js.map